import type { FC } from 'react';

import { starBaseRecipe, starRecipe, starWrapperRecipe } from './RatingStar.css';
import { StarFullIcon, StarEmptyIcon } from '../../icons';
import { getClassNames } from '../../util/css';
import { Stack } from '../Stack/Stack';

type StarFill = 'full' | 'threeQuarter' | 'half' | 'quarter' | 'empty';

function getDetailedStarFills(score: number, totalStars: number): StarFill[] {
  const starFills: StarFill[] = [];
  const normalizedScore = (score / 10) * totalStars;

  for (let i = 0; i < totalStars; i++) {
    const diff = normalizedScore - i;

    if (diff >= 0.875) {
      starFills.push('full');
    } else if (diff >= 0.625) {
      starFills.push('threeQuarter');
    } else if (diff >= 0.375) {
      starFills.push('half');
    } else if (diff >= 0.125) {
      starFills.push('quarter');
    } else {
      starFills.push('empty');
    }
  }

  return starFills;
}

type StarSizes = 'small' | 'medium' | 'large' | 'extraLarge';

type RatingSummaryProps = {
  maxStars: number;
  score: number;
  size?: StarSizes;
};

export const RatingStar: FC<RatingSummaryProps> = ({ maxStars = 5, size = 'small', score }) => {
  const fills = getDetailedStarFills(score, maxStars);

  return (
    <Stack direction="row" gap="0">
      {fills.map((fill, i) => {
        return (
          <div className={getClassNames(starWrapperRecipe({ size }))} key={i}>
            <div className={getClassNames(starBaseRecipe({ size }))}>
              <StarEmptyIcon color="feedbackSuccess" size={size} />
            </div>
            <div className={getClassNames(starRecipe({ size, fill }))}>
              <StarFullIcon color="feedbackSuccess" size={size} />
            </div>
          </div>
        );
      })}
    </Stack>
  );
};

export default RatingStar;
